"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ProductContentVideoSaga_1 = require("../../productContentVideo/sagas/ProductContentVideoSaga");
const loadProductContentVideoeModule = () => ({
    id: 'ProductContentVideos',
    sagas: [ProductContentVideoSaga_1.default],
});
exports.default = loadProductContentVideoeModule;
